import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Modal } from 'ksnm-common-ui/lib/Modal';

import styles from './ErrorsModal.module.scss';

interface IErrorsModal {
  errors: string[];
  open: boolean;
  toggle: () => void;
  title?: string;
}

export const ErrorsModal = observer(({ errors, open, toggle, title }: IErrorsModal) => (
  <Modal
    open={open}
    className={styles.modal}
    centered
    footer={null}
    onCancel={toggle}
    width={1600}
    closeIcon={<Icon name="close" noFill height={24} />}
  >
    <div className={styles.container}>
      <h1 className={styles.title}>
        <Icon name="info" fill="#E63D29" height={24} className={styles.errorIcon} /> {title}
      </h1>
      <div className={styles.rows}>
        {errors.map((item, index) => (
          <div className={styles.row} key={index}>
            {item}
          </div>
        ))}
      </div>
    </div>
  </Modal>
));
